import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wzhxy9syvt: FaireBrandEntity = {
  token: "b_wzhxy9syvt",
  type: "brand",
  name: "Ginger Lily Tallow",
  avatarUrl:
    "https://cdn.faire.com/fastly/5ad34d97eb8ffe9f06740735f60524e6748f4883dd7052b514560aa0732b199c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e7136e9699e984acae9eb60773390fb0cfabef06f39457adb9a6673268cb7e0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5ad34d97eb8ffe9f06740735f60524e6748f4883dd7052b514560aa0732b199c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e7136e9699e984acae9eb60773390fb0cfabef06f39457adb9a6673268cb7e0.png",
  location: "Mooresville, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Ginger Lily Tallow was born from a makeup artist’s search for skincare that truly heals. Founder Adrienne McCann fused her years in the profession with a personal health journey to create something radically simple and exceptionally effective: skincare and makeup made from nutrient-dense, grass-fed tallow. What began as a handcrafted remedy in a small kitchen is now BioGlow — the world’s first tallow-based tinted foundation — and a full lineup of small-batch essentials designed to restore and protect skin.\n\nOur formulas celebrate whole-ingredient efficacy over trends. We pair sustainably sourced tallow with thoughtfully selected botanicals and mineral sunscreens to create multi-tasking, low-irritation products that nourish skin at a cellular level. Everything is made in small batches with transparency and intentionality — from ingredient sourcing to labeling — because we believe beauty should feel as good on the inside as it looks on the outside.\n\nGinger Lily Tallow is a brand for people who want fewer, better products that actually work. Independent retailers choose us because BioGlow is a true category innovator (tallow + coverage + SPF), and because our story — grounded in artisanal craft, clean formulation, and a founder’s real-world expertise — connects with customers who value authenticity and results.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:41.144Z",
    importedBy: "entity-db-cli",
  },
};
